import { User, UserState } from './user';

export default {
	setUser(state: UserState, user: User): void {
		state.user = user
	},
	setLoader(state: UserState): void {
		state.loader = !state.loader
	},
}